import {createContext} from "react";
export const WebSocketContext = createContext(null);
